<template>
  <div class="record-number">
    <!-- <el-form-item prop="recordType" > -->
      <label slot="label" v-if="disabled" v-html="`${inputCard.label.content}${inputCard.label.icon_msg ? `(${inputCard.label.icon_msg})`:''}`"></label>
      <div >
        <el-select v-model="form.recordType" :disabled="disabled" @change="change($event,'recordType')" clearable placeholder="请选择">
          <el-option v-for="item in options" :key="item.type" :label="item.text" :value="item.type"></el-option>
        </el-select>
      </div>
      <div v-if="options.length>0" style="margin-bottom:4px">
        <el-input v-model="input[0]" class="short" @change="change($event,'input')" placeholder="请输入" :disabled="disabled"></el-input>{{ getText(1) }}
        <el-input v-model="input[1]" class="short" @change="change($event,'input')" placeholder="请输入" :disabled="disabled"></el-input>{{ getText(2) }}
        <el-input v-model="input[2]" class="short" @change="change($event,'input')" placeholder="请输入" :disabled="disabled"></el-input>{{ getText(3) }}
      </div>
    <!-- </el-form-item> -->
  </div>
</template>
<script>
import { getData } from "../../utils/utils";
export default {
  name: "record-number",
  components: {
 
  },
  props: {
    value: [Object,String],
    inputKey: String,
    inputCard: Object,
    disabled:Boolean
  },
  watch: {
  },
  data() {
    return {
      form: {
        recordType: '',
        recordText: ""
      },
      options: [
        // {type:0,text:'重点备案号',detail:'###网微剧审字###第###号'},
        // {type:1,text:'普通备案号',detail:'###网微剧备字###第###号'},
      ],
      input:['','','']
    };
  },
  created() {
    const params = {}
    if (this.$route.query['loginParam']) {
      params.loginParam=this.$route.query['loginParam']
    }
    getData('/api/field/config/report', params,
    (res) => {
      if (res.code == 0) {
        if (res.data && res.data.length > 0) {
          this.options = res.data
        }
      }
      })
    if (this.value&&this.value.recordText) {
      this.form = this.value;
    }
    this.input = this.form.recordText.split('###')
    
  },
  computed: {
    getText() {
      return function (i) {
        const index = this.options.findIndex(item => item.type == this.form.recordType) || 0
        return this.options[index].detail.split('###')[i]
      }
    }
  },
  methods: {
    change(val,key) {
      if (key == 'input') { 
        this.form.recordText = this.input.join('###')
      }
      this.$emit("change", { key:this.inputKey,value:this.form });
    }
  }
};
</script>
<style >
.short.el-input{
  width: auto;
  margin-top: 10px;
  margin-right: 5px;
}
.short.el-input input{
  width:113px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/RecordNumber.vue